import ActivityIcon from '../ActivityIcon.js';
import Ajax from '../../../../../common/js/Ajax.js';
import DatePickerWidget from '../../../../../common/js/datepicker/DatePickerWidget.js';
import Dialog from '../../../../../common/js/dialog/Dialog.js';
import Form from '../../../../../common/js/form/Form.js';
import MessageUtils from '../../../../../common/js/MessageUtils.js';
import TippspielWidget from '../../TippspielWidget.js';
import UrlParser from '../../../../../common/js/UrlParser.js';
import WidgetLoader from '../../../../../common/js/WidgetLoader.js';

import TEMPLATE from './SeasonWidget.hbs';

export default class SeasonWidget extends TippspielWidget {

	constructor($widget) {
		super($widget);
		this.seasonId = parseInt(UrlParser.getParams()['id']);

		Form.onSubmit(this.$widget, '.js_winner-end-date-form', action => {
			Ajax.rpc('/saveSeasonWinnerEndDate', {
				seasonId: this.seasonId,
				winnerEndDate: DatePickerWidget.getDate(action.find('.js_winner-end-date'))
			}, () => {
				action.ok();
			}, error => {
				action.error('Speichern des Enddatums fehlgeschlagen', error);
			});
		});

		Form.onSubmit(this.$widget, '.js_create-phase', action => {
			Ajax.rpc('/createPhase', {
				seasonId: this.seasonId,
				name: action.findField('name').val(),
				scoreFactor: action.findField('scoreFactor').val()
			}, () => {
				action.ok();
				this.refresh();
			}, error => {
				action.error('Anlegen der Phase fehlgeschlagen', error);
			});
		});

		Form.onSubmit(this.$widget, '.js_create-match', action => {
			var startDate = DatePickerWidget.getDate(action.find('.js_start-date'));
			var [hour, minute] = action.findField('start-time').val().split(':');
			startDate.setHours(parseInt(hour));
			startDate.setMinutes(parseInt(minute));
			startDate.setSeconds(0);
			startDate.setMilliseconds(0);

			Ajax.rpc('/createMatch', {
				phaseId: action.$form.closest('.js_phase').attr('data-id'),
				startDate
			}, () => {
				action.ok();
				this.refresh();
			}, error => {
				action.error('Anlegen der Phase fehlgeschlagen', error);
			});
		});

		this.$widget.on('click', '.js_delete-phase', event => {
			var $phase = $(event.currentTarget).closest('.js_phase');
			Dialog.question('Phase löschen',
				'Bist du sicher, dass du die Phase löschen möchtest?',
				true, 'Phase löschen',
				() => {
					Ajax.rpc('/deletePhase', {id: $phase.attr('data-id')}, () => {
						this.refresh();
					}, error => {
						MessageUtils.error($widget, 'Löschen der Phase fehlgeschlagen', error);
					});
				});
		});

		this.$widget.on('click', '.js_delete-match', event => {
			var $match = $(event.currentTarget).closest('.js_match');
			Dialog.question('Spiel löschen',
				'Bist du sicher, dass du das Spiel löschen möchtest?',
				true, 'Spiel löschen',
				() => {
					Ajax.rpc('/deleteMatch', {id: $match.attr('data-id')}, () => {
						this.refresh();
					}, error => {
						MessageUtils.error($widget, 'Löschen des Spiels fehlgeschlagen', error);
					});
				});
		});

		this.$widget.on('change', '.js_team', event => {
			var $match = $(event.currentTarget).closest('.js_match');
			var $activityIcon = $match.find('.js_activity-icon');
			var runningId = ActivityIcon.setRunning($activityIcon);
			Ajax.rpc('/saveMatchTeams', {
				matchId: $match.attr('data-id'),
				team1Id: $match.find('[name="team1"]').val(),
				team2Id: $match.find('[name="team2"]').val()
			}, () => {
				ActivityIcon.setSuccess($activityIcon, runningId);
			}, error => {
				ActivityIcon.setNone($activityIcon);
				MessageUtils.error($widget, 'Aktualisieren des Spiels fehlgeschlagen', error);
			});
		});
	}

	isLoginRequired() {
		return true;
	}

	isAdminRequired() {
		return true;
	}

	onLoginReady() {
		this.refresh();
	}

	refresh() {
		Ajax.rpc('/season', {id: this.seasonId}, season => {
			this.setPageHeadline(season.name);
			this.$widget.html(TEMPLATE(season));

			WidgetLoader.initialize();
		}, error => {
			MessageUtils.error(this.$widget, 'Laden der Meisterschaft fehlgeschlagen', error);
		});
	}
}
